import { useState, useEffect } from 'react';

const INTERSTITIALS = [
  'Considering your answer...',
  'Thinking about what to ask next...',
  'Finding the right question...',
  'Working with what you gave me...',
];

export default function ThinkingIndicator() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((i) => (i + 1) % INTERSTITIALS.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="mb-8 py-6" aria-live="polite" aria-label="Processing">
      <div className="text-[11px] font-semibold uppercase tracking-[0.12em] text-muted-foreground mb-4 inline-flex items-center gap-2">
        <span className="w-1.5 h-1.5 rounded-full bg-primary animate-pulse" aria-hidden="true" />
        The press
      </div>
      <div className="font-display text-lg text-muted-foreground italic [font-variation-settings:'opsz'_48,'SOFT'_80]">
        {INTERSTITIALS[index]}
      </div>
    </div>
  );
}
